import styled from 'styled-components';

export const SweepTextWrap = styled.pre`
  overflow-y: auto;
  max-height: 100%;
`;
